var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagellanLogoGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 41,
    viewBox: "0 0 294 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8515 31.5283L54.8708 38.4293L51.8902 31.5283H50.1289V39.6471H51.0773V32.0696H51.2128L54.4644 39.6471H55.2773L58.5289 32.0696H58.6644V39.6471H59.6128V31.5283H57.8515Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4387 39.6471H65.9806V31.5283H65.4387V39.6471Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2456 30.8516H71.4004V38.9704H74.2456C77.3617 38.9704 78.581 37.076 78.581 34.911C78.581 32.746 77.3617 30.8516 74.2456 30.8516ZM74.2456 38.4289H72.3488V31.5279H74.2456C76.4133 31.5279 77.6326 32.7458 77.6326 34.9108C77.6326 37.2111 76.4133 38.4289 74.2456 38.4289Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7807 36.8049C83.1871 38.0228 84 38.564 85.6258 38.564C86.8452 38.564 87.6581 37.8874 87.6581 36.9402C87.6581 34.7752 82.2387 35.5871 82.2387 32.8808C82.2387 31.663 83.3226 30.7158 85.0839 30.7158C86.7097 30.7158 87.7936 31.3924 88.3355 32.6102L87.5226 32.8808C87.1162 31.9336 86.4387 31.3924 85.0839 31.3924C84 31.3924 83.1871 31.9336 83.1871 32.8808C83.1871 33.4221 83.3226 33.828 85.2194 34.3693C88.0645 35.1812 88.6065 35.7224 88.6065 36.9402C88.6065 38.2934 87.1162 39.1053 85.6258 39.1053C83.5936 39.1053 82.5097 38.4287 81.9678 36.9402L82.7807 36.8049Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4834 31.5283V32.0696H96.464V39.6471H97.2769V32.0696H100.258V31.5283H93.4834Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.148 39.6471H111.096L108.793 35.723C110.148 35.4524 110.825 34.7758 110.825 33.6933C110.825 32.3402 109.606 31.5283 107.709 31.5283H104.322V39.6471H105.271V35.9937H107.845L110.148 39.6471ZM107.709 35.3178H105.271V32.0703H107.709C109.2 32.0703 109.877 32.7468 109.877 33.694C109.877 34.7765 109.064 35.3178 107.709 35.3178Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.517 31.5283V39.6471H121.936V39.1059H117.33V35.723H120.446V35.1818H117.33V32.0696H121.665V31.5283H116.517Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.646 39.6471L128.033 31.5283H129.523L132.775 39.6471H131.691L130.607 36.9409H126.678L125.594 39.6471H124.646ZM130.471 36.265L128.71 32.0703L126.949 36.265H130.471Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.561 31.5283L141.581 38.4293L138.6 31.5283H136.839V39.6471H137.787V32.0696H137.923L141.174 39.6471H141.987L145.239 32.0696H145.374V39.6471H146.323V31.5283H144.561Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.161 31.5283V39.6471H158.245V36.129H160.413C162.851 36.129 163.935 35.1818 163.935 33.8287C163.935 32.4755 162.987 31.5283 160.413 31.5283H157.161ZM160.277 35.4533H158.11V32.2057H160.277C162.039 32.2057 162.851 32.747 162.851 33.8295C162.851 34.912 162.174 35.4533 160.277 35.4533Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.646 39.6471L170.033 31.5283H171.387L174.639 39.6471H173.691L172.607 36.9409H168.678L167.594 39.6471H166.646ZM172.471 36.265L170.71 32.0703L168.949 36.265H172.471Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.665 39.6471H185.613L183.31 35.723C184.665 35.4524 185.342 34.7758 185.342 33.6933C185.342 32.3402 184.123 31.5283 182.226 31.5283H178.839V39.6471H179.787V35.9937H182.361L184.665 39.6471ZM182.226 35.3178H179.787V32.0703H182.226C183.716 32.0703 184.394 32.7468 184.394 33.694C184.394 34.7765 183.581 35.3178 182.226 35.3178Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.678 31.5283V32.0696H192.658V39.6471H193.471V32.0696H196.452V31.5283H189.678Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.478 31.5283V38.294H206.342L202.007 31.5283H200.517V39.6471H201.33V32.0696H201.465L206.342 39.6471H207.291V31.5283H206.478Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.064 31.5283V39.6471H219.484V39.1059H214.877V35.723H217.993V35.1818H214.877V32.0696H219.213V31.5283H214.064Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.645 38.9704H230.729L228.291 35.1816C229.645 34.911 230.323 34.2344 230.323 33.1519C230.323 31.7988 229.239 30.8516 227.207 30.8516H223.955V38.9704H224.903V35.3169H227.478L229.645 38.9704ZM227.342 34.6401H224.903V31.5279H227.342C228.697 31.5279 229.51 31.9339 229.51 33.0164C229.51 34.0989 228.697 34.6401 227.342 34.6401Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.201 36.8049C235.607 38.0228 236.42 38.564 238.046 38.564C239.265 38.564 239.943 37.8874 239.943 36.9402C239.943 34.7752 234.659 35.5871 234.659 32.8808C234.659 31.663 235.607 30.7158 237.504 30.7158C238.994 30.7158 240.214 31.3924 240.62 32.6102L239.807 32.8808C239.401 31.9336 238.723 31.3924 237.504 31.3924C236.284 31.3924 235.607 31.9336 235.607 32.8808C235.607 33.4221 235.743 33.828 237.639 34.3693C240.349 35.1812 240.891 35.7224 240.891 36.9402C240.891 38.2934 239.536 39.1053 237.91 39.1053C236.014 39.1053 234.93 38.4287 234.388 36.9402L235.201 36.8049Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.632 38.2939V39.3765H245.903L245.361 41.0002H245.768L246.445 39.3765V38.2939H245.632Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.774 31.5283V39.6471H264.194V39.1059H259.723V31.5283H258.774Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.529 39.2411H269.342V38.6999H268.529V39.2411Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.678 31.5283V39.6471H274.762V36.129H276.929C279.368 36.129 280.452 35.1818 280.452 33.8287C280.452 32.4755 279.504 31.5283 276.929 31.5283H273.678ZM276.794 35.4533H274.626V32.2057H276.794C278.555 32.2057 279.368 32.747 279.368 33.8295C279.368 34.912 278.691 35.4533 276.794 35.4533Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.432 39.2411H284.245V38.6999H283.432V39.2411Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4834 0.40625V26.1158H56.9028V6.22473L64.4899 26.1158H71.1286L78.4447 6.63067V26.1158H83.9995V0.541564H75.0576L67.7415 20.8386L60.1544 0.40625H51.4834Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.781 0.40625H97.4132L86.71 26.1158H93.2132L95.6519 20.2973H106.491L108.658 26.1158H115.162L103.781 0.40625ZM104.323 15.8314H97.4132L100.8 6.90074L104.323 15.8314Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.329 13.1254C117.329 6.35974 122.071 0 128.981 0H145.239V4.73597H130.471C126.407 4.73597 124.239 9.06601 124.239 12.9901C124.103 17.0495 126.271 21.6502 130.336 21.6502H139.142V15.1551H130.065V10.8251H145.374V26.1155H128.032C121.394 26.1155 117.329 19.6205 117.329 13.1254Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.723 24.6275C146.594 20.7034 146.594 5.6836 154.723 1.48888C157.026 0.406369 158.652 0.135742 161.226 0.135742H173.149V4.7364H162.174C160.278 4.7364 159.058 5.14234 157.703 6.49548C156.484 7.84861 155.942 9.06643 156.078 10.9608H173.284V15.5615H155.942C155.942 17.1852 156.349 18.4031 157.432 19.4856C158.516 20.8387 159.736 21.5153 161.497 21.5153H173.013V25.9806H160.278C158.11 25.9806 156.755 25.5747 154.723 24.6275Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.445 16.7793C183.445 18.2678 183.716 19.215 184.664 20.2975C186.019 21.9212 187.781 22.1918 189.948 22.1918H198.348V26.3866H188.864C183.987 26.3866 179.652 25.5747 177.619 21.38C176.942 19.7562 176.671 18.6737 176.671 16.9146V0.135742H183.445V16.7793Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.239 16.7793C208.239 18.2678 208.51 19.215 209.458 20.2975C210.813 21.9212 212.575 22.1918 214.742 22.1918H223.142V26.3866H213.658C208.781 26.3866 204.445 25.5747 202.413 21.38C201.736 19.7562 201.465 18.6737 201.465 16.9146V0.135742H208.239V16.7793Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.974 0.40625H235.607L224.903 26.1158H231.407L233.71 20.2973H244.548L246.716 26.1158H253.219L241.974 0.40625ZM239.129 6.90074L242.652 15.8314H235.607L239.129 6.90074Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.419 1.75879H265.819L278.148 20.9733V1.75879H284.516V27.4684H276.251L263.516 8.65978L263.651 27.333H257.419V1.75879Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.40625V28.8221L13.2774 12.0432L23.3032 23.0036L30.3484 15.9673L43.3548 32.8815V0.40625H0Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32.0691V40.9998H6.23226L21.6774 24.2209L14.3613 19.3496L0 32.0691Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8389 41.0001H43.355V34.6404L33.0582 27.4688L10.8389 41.0001Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.768 1.6245C287.632 1.21856 287.497 1.08325 287.226 1.08325C286.955 1.08325 286.819 1.21856 286.819 1.48919C286.819 2.03044 288.581 2.16575 288.581 3.38358C288.581 4.06014 288.039 4.46608 287.226 4.46608C286.549 4.46608 286.007 4.19546 285.871 3.38358L286.684 3.24826C286.819 3.78952 287.09 3.92483 287.361 3.92483C287.632 3.92483 287.903 3.78952 287.903 3.51889C287.903 2.84232 286.142 2.70701 286.142 1.6245C286.142 0.947933 286.549 0.541992 287.361 0.541992C288.039 0.541992 288.445 0.947933 288.716 1.48919L287.768 1.6245Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.781 0.40625L291.968 3.11252L291.155 0.40625H289.936V4.46566H290.748V1.21813L291.697 4.46566H292.239L293.187 1.21813V4.46566H294V0.40625H292.781Z",
    fill: "#B7BCC5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 294,
    height: 41.0001,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagellanLogoGrey);
export default __webpack_public_path__ + "static/media/magellan-logo-grey.4d08101483fe2697de042d76d1022715.svg";
export { ForwardRef as ReactComponent };